module.exports = __webpack_public_path__ + "static/woelfleder.62fa3d2d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/customers/woelfleder.jpg
// module id = 136
// module chunks = 2129169737660 35783957827783